import React, { useMemo, useState } from "react"; // Importamos useMemo
import { useToast } from "../../../../hooks/useToast";
import { AdministrarPatEdit, PatDTO } from "../models/administrarPat";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import ActionMenu, { Action } from "../../../../components/ui/materialui/actionMenu"; // Importamos tipo Action si existe
import { eliminarPat } from "../service/servicePat";
import { TipoFuncionalidad } from "../../../../utils/enums"; // Importamos TipoFuncionalidad
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import { GridDeleteIcon } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import { usePermissions } from "../../../../components/auth/ProtectedRoute"; // Importamos hook de permisos


interface IProps {
    pat: PatDTO;
    control: any;
    setPatEditar: React.Dispatch<React.SetStateAction<AdministrarPatEdit | undefined>>;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
    isEdit: (value: boolean) => void;
}

const AccionesPat: React.FC<IProps> = ({ pat, control, setPatEditar, setModalDetalle, isEdit }) => {
    const { addToast } = useToast();
    const { hasPermission } = usePermissions(); 
    
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => { },
    });

    const isValueEmpty = (value: any): boolean => {
        if (value === null || value === undefined) return true;
        if (typeof value === 'string' && value.trim() === '') return true;
        if (typeof value === 'number' && value === 0) return true;
        return false;
    };

    const isCreateMode = isValueEmpty(pat.llavePat) || isValueEmpty(pat.estado);

    const handleEditarClick = () => {
        const patParaEditar: AdministrarPatEdit = {
            mutuoId: pat.id || 0,
            llavePat: String(pat.llavePat),
            bancoCodigo: '',
            fechaPrimerDescuento: new Date(),
            tipoCuota: '',
            diaCobro: 0,
            numeroMandato: 0,
            numeroOperacion: '',
            estado: pat.estado ?? '',
            montoCuota: 0,
            observaciones:'',
            nombreCliente: pat.nombreCompleto ?? '',
            numeroTarjeta: '',
            tipoTarjetaCodigo:'',
            fechaVencimientoTarjeta: new Date(),
            codigoMoneda: '',
            tipoProducto: pat.tipoProducto,
            numeroSolicitud: pat.numeroSolicitud,
        };
        setPatEditar({ ...patParaEditar });
        setModalDetalle(true);
        isEdit(true);
    };

    const handleCrearClick = () => {
        const patParaCrear: AdministrarPatEdit = {
            mutuoId: pat.id,
            llavePat: pat.numeroSolicitud?.toString() ?? '',
            bancoCodigo: '',
            fechaPrimerDescuento: new Date(),
            tipoCuota: '',
            diaCobro: 0,
            numeroMandato: 0,
            numeroOperacion: pat.numeroOperacion ?? '',
            estado: '',
            montoCuota: 0,
            observaciones: '',
            nombreCliente: pat.nombreCompleto ?? '',
            numeroTarjeta: '',
            tipoTarjetaCodigo: '',
            fechaVencimientoTarjeta: new Date(),
            codigoMoneda: pat.codigoMoneda,
            tipoProducto: pat.tipoProducto,
            numeroSolicitud: pat.numeroSolicitud,
        };
        setPatEditar(patParaCrear);
        setModalDetalle(true);
        isEdit(false)
    };

    const handleEliminarClick = () => {
        setModalConfirmacion({
            show: true,
            title: 'Confirmar Eliminación',
            message: `¿Está seguro de eliminar el PAT para el mutuo seleccionado?`,
            metodo: () => confirmarEliminar(),
        });
    };

    const confirmarEliminar = async () => {
        try {
            const eliminado = await eliminarPat(pat.id);
            if (eliminado) {
                addToast({
                    mostrar: true,
                    titulo: 'Éxito',
                    tipo: 'Success',
                    mensaje: 'La Acción se ha completado con éxito. Recuerde regenerar el dividendo vigente.'
                });
                control.fetchData();
            }
        } catch (error) {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'Error al eliminar el PAT'
            });
        } finally {
            setModalConfirmacion(prev => ({ ...prev, show: false }));
        }
    };

    const actions = useMemo<Action[]>(() => {
        const items: Action[] = [];
        
        const tienePermisoAdm = hasPermission(TipoFuncionalidad.Recaudacion_adm);

        if (!tienePermisoAdm) return items; 

        if (isCreateMode) {
            items.push({ 
                label: "Crear", 
                icon: <AddCircleOutlineTwoToneIcon fontSize="small" />, 
                onClick: handleCrearClick 
            });
        } else {
            items.push(
                { 
                    label: "Editar", 
                    icon: <EditIcon fontSize="small" />, 
                    onClick: handleEditarClick 
                },
                { 
                    label: "Eliminar", 
                    icon: <GridDeleteIcon fontSize="small" />, 
                    onClick: handleEliminarClick 
                }
            );
        }

        return items;
    }, [hasPermission, isCreateMode, pat]); 

    return (
        <>
            <ConfirmationModal
                onHide={() => setModalConfirmacion(prev => ({ ...prev, show: false }))}
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
            {actions.length > 0 && <ActionMenu actions={actions} />}
        </>
    );
};

export default AccionesPat;